export default __webpack_public_path__ + "static/media/habano4.1cd54917.png";